import { render, staticRenderFns } from "./MoleculeHeadingTextButton.vue?vue&type=template&id=0de8767d"
import script from "./MoleculeHeadingTextButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeHeadingTextButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports